import call from './call';
import {GET_LOGS} from "../types";
import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";

export default (form,onFinishCallBack) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success) {
            let reports={entries: result[1].results, total: result[1].total, kind: 'logs',file:result[1].result};
            if(reports.file)
                handleBase64ZipResponse(reports.file, "logs.zip");
            else
            {
                if (onFinishCallBack)
                    onFinishCallBack(reports);
                dispatch({type: GET_LOGS, payload: {reports: reports}});
            }
        }
    };
    dispatch(call("SystemService/getLogsGrid",form,onResult));
};